import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingImageQualityImproverConfig } from '@/data/landingConfig/landingImageQualityImproverConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_ImageQualityImprover } from './schemaObject';

const ImageQualityImprover = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_ImageQualityImprover} />
			<LandingTemplate
				data={landingImageQualityImproverConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageEnhancementV2()}
			/>
		</>
	);
};

export default ImageQualityImprover;
